import { render } from "./TheFacilityCard.vue?vue&type=template&id=3112bb6e&scoped=true"
import script from "./TheFacilityCard.vue?vue&type=script&lang=js"
export * from "./TheFacilityCard.vue?vue&type=script&lang=js"

import "./TheFacilityCard.vue?vue&type=style&index=0&id=3112bb6e&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-3112bb6e"

export default script